export default __webpack_public_path__ + "static/media/2.87d85358.jpg";